import clsx from 'clsx';
import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import Link from 'next/link';

import { EnterButton } from '../enter-button/EnterButton';
import { PrizeCarousel } from './PrizeCarousel';
import styles from './PrizesSection.module.css';

const PRIZES_SECTION_TITLE = '1 entry, 400+ prizes';

export const PrizesSection = ({ isSubscriber }: { isSubscriber: boolean }) => {
  return (
    <AboutUsModule background={'white'}>
      <div className={styles.container}>
        <AboutUsSiteContainer>
          <div className={styles.container}>
            <h2
              className={`aboutUsTypographyHeaderXlargeOnWhite ${styles.textMaxWidth}`}
              data-text={PRIZES_SECTION_TITLE}
            >
              {PRIZES_SECTION_TITLE}
            </h2>
            <p className={`textAlignCenter noMargin`}>
              1 entry into our weekly draws will give you the chance to win epic
              prizes like these & more!
            </p>
          </div>
        </AboutUsSiteContainer>

        <div className={clsx(styles.prizeCarouselContainer)}>
          <PrizeCarousel />
        </div>
        <div className={styles.container}>
          <p className="aboutUsTypographyBodySmall textAlignCenter noMargin">
            🏆{' '}
            <strong className="textDecorationUnderline">
              <Link href="/prizes">View All Prizes</Link>
            </strong>{' '}
            🏆
          </p>
          {!isSubscriber && <EnterButton />}
        </div>
      </div>
    </AboutUsModule>
  );
};
